import { deleteREST, get, put, patch, post } from '../util/ajax';
export const fetchPeopleSkills = params => {
  return get('people/skills', { params });
};

export const fetchSkillLevelDescription = skillId => {
  return get(`skill/${skillId}/level-descriptions`);
};

export const updatePeopleSkills = body => {
  return put('people/skills', body);
};

export const createPeopleSkills = (id, body) => {
  return post(`people/skills/${id}`, body);
};

export const updateSkill = (id, body) => {
  return patch(`people/skills/${id}`, body);
};

export const removeSkillById = id => {
  return deleteREST(`people/skills/${id}`);
};
